import { FC } from 'react';

import { Button, Stack } from '@mui/material';

import { IcFilter } from '@/assets/images';
import { BaseAutocomplete } from '@/components';

export const UnitFilter: FC = () => {
  return (
    <div style={{ width: 250 }}>
      <Stack flexDirection="row">
        <BaseAutocomplete
          placeholder="Select filter..."
          value=""
          items={[]}
          onChange={() => {}}
          sx={{ minWidth: 0, marginBottom: -2 }}
          showPopupIcon
        />
        <Button
          color="inherit"
          variant="outlined"
          style={{
            padding: '0px 10px',
            height: 36,
            minWidth: 40,
            marginLeft: 10,
          }}
          onClick={() => {}}
          sx={{ position: 'relative' }}
        >
          <IcFilter />
        </Button>
      </Stack>
    </div>
  );
};
